// extracted by mini-css-extract-plugin
export default {"cls1":"Bv9b1HVTg3Xkn_dl8SOU","cls2":"HHLXsV72fqYElugzAEK0 Bv9b1HVTg3Xkn_dl8SOU"};